import { queryConfigValue, queryChannelInfo } from "@/apis/common"
import { getActiveDomain } from "@/utils/IMEI";
import { TOGGLE_CONFIG_KEY, CAPTCHA_ID_CONFIG_KEY } from "@/utils/yidunCaptcha";

// 易盾配置的在途请求。放在模块作用域而不是 state 里：Promise 不适合进 Vuex（不可序列化、
// 会被 vuex-logger 打出来），这里只用于把「连点几下获取验证码」并发的请求合成一次。
let yidunConfigPromise = null;

const state = {
  appName: '红狮金业',
  androidMt4DownloadUrl: '',
  androidDownloadUrl: '',
  iosMt4DownloadUrl: '',
  iosMt5DownloadUrl: '',
  isAICustomService: false,
  tradeWapLink: '',
  live800Url: 'https://care80.live800.com/chat/chatClient/chatbox.jsp?companyID=80028755&configID=1084',
  live800UrlUc: 'https://care80.live800.com/chat/chatClient/chatbox.jsp?companyID=80028755&configID=1084',
  newAndroidMt4: 'https://download.terminal.free/cdn/mobile/mt4/android?server=RedLionBullion-Demo,RedLionBullion-Live',
  newAndroidMt5: 'https://download.terminal.free/cdn/mobile/mt5/android?server=RedLionBullion-Server',
  newiosMt4: 'https://download.terminal.free/cdn/mobile/mt4/ios?server=RedLionBullion-Demo,RedLionBullion-Live',
  newiosMt5: 'https://download.terminal.free/cdn/mobile/mt5/ios?server=RedLionBullion-Server',
  tradeListUrl: '',
  aiUrl: '',
  // 网易易盾行为验证码配置 { toggle, captchaId }，null 表示还没拉过。
  // 只在内存里缓存，刷新页面即重新拉取，后台改完配置刷新即生效
  yidunCaptchaConfig: null,
}

const mutations = {
  SET_ANDROID_URL(state, url) {
    state.androidDownloadUrl = url
  },
  SET_ANDROID_MT4_URL(state, url) {
    state.androidMt4DownloadUrl = url
  },
  SET_IOS_MT4_URL(state, url) {
    state.iosMt4DownloadUrl = url
  },
  SET_IOS_MT5_URL(state, url) {
    state.iosMt5DownloadUrl = url
  },
  SET_IS_AICUSTOMSERVICE(state, data) {
    state.isAICustomService = data
  },
  SET_TRADE_WAP_LINK(state, data) {
    state.tradeWapLink = data
  },
  SET_LIVE_URL(state, data) {
    state.live800Url = data
  },
  SET_LIVE_UC_URL(state, data) {
    state.live800UrlUc = data
  },
  SET_Android_MT4_URL(state,data){
    state.newAndroidMt4=data
  },
  SET_Android_MT5_URL(state, data) {
    state.newAndroidMt5 = data
  },
  SET_TRADE_LIST_URL(state, data) {
    state.tradeListUrl = data
  },
  SET_AI_URL(state, data) {
    state.aiUrl = data
  },
  SET_YIDUN_CAPTCHA_CONFIG(state, data) {
    state.yidunCaptchaConfig = data
  },
}

const actions = {
  async getAndroidDownloadUrl({ commit }, code = 'N9999') {
    const res = await queryChannelInfo(code);
    const { downloadUrl = '', mt4UpdateUrl } = res;
    let apkurl = downloadUrl || '';
    const { origin } = window.location;
    const absoluteURLRegex = /^[a-zA-Z]+:\/\/.+/;
    if (absoluteURLRegex.test(downloadUrl)) {
      apkurl = downloadUrl
    } else {
      apkurl = origin + '/' + downloadUrl
    }
    commit('SET_ANDROID_URL', apkurl)
    commit('SET_ANDROID_MT4_URL', apkurl)
  },
  async getIosDownloadUrl({ commit }, key = 'IOSDownLoadLink') {
    const res = await queryConfigValue({key});
    if(res) {
      const Rhref = window.location.host;

      if(key === 'IOSDownLoadLinkMT5') {
        if (Rhref.indexOf('rlchltd') > -1) {
   


          commit('SET_IOS_MT5_URL', await getActiveDomain(state.tradeListUrl))

        } else {
          commit('SET_IOS_MT5_URL', res)
        }
      } else {
        if (Rhref.indexOf('rlchltd') > -1) {
      


          commit('SET_IOS_MT4_URL', await getActiveDomain(state.tradeListUrl))

        } else {
          commit('SET_IOS_MT4_URL', res)
        }
      }
    }
  },
  async getmt4DownloadUrls({ commit }, key = 'MT4AndroidDownload') {
    const res = await queryConfigValue({ key });
    if (res) {

      let apkurl = res || '';
      const { origin } = window.location;
      const absoluteURLRegex = /^[a-zA-Z]+:\/\/.+/;
      if (absoluteURLRegex.test(res)) {
        apkurl = res
      } else {
        apkurl = origin  + res
      }
    

      // commit('SET_Android_MT4_URL', apkurl)
      
    }
  },
  async getmt5DownloadUrls({ commit }, key = 'MT5AndroidDownload') {
    const res = await queryConfigValue({ key });
    if (res) {
      let apkurl = res || '';
      const { origin } = window.location;
      const absoluteURLRegex = /^[a-zA-Z]+:\/\/.+/;
      if (absoluteURLRegex.test(res)) {
        apkurl = res
      } else {
        apkurl = origin + res
      }
    
      // commit('SET_Android_MT5_URL', apkurl)
      
    }
  },
  async getAICustomService({ commit }) {
    const res = await queryConfigValue({key: 'ServiceModeN9999'});
    let urls = '';
    if(res === '1') {
      commit('SET_IS_AICUSTOMSERVICE', true)
      urls = await queryConfigValue({key: 'AiServiceUrlN9999'});
    } else {
      commit('SET_IS_AICUSTOMSERVICE', false)
      urls = await queryConfigValue({key: 'HumanServiceUrl'});
    }
    const serviceUrl = await getActiveDomain(urls);
    sessionStorage.setItem('liveUC', serviceUrl)
    commit('SET_LIVE_UC_URL', serviceUrl)
    sessionStorage.setItem('liveH5', serviceUrl)
    commit('SET_LIVE_URL', serviceUrl)
    commit('SET_AI_URL', serviceUrl)
  },
  handleDownload({ state }) {
    var u = navigator.userAgent;
    if (/(iPhone|iPad|iPod|iOS)/i.test(u)) { //苹果
      try {
        window.webkit.messageHandlers.gotoRegisterReal.postMessage('1');
      } catch (error) {
        window.open(state.iosMt5DownloadUrl);
      }
    } else { // 安卓
      try {
        window.android.gotoRegisterReal();
      } catch (error) {
        window.open(state.androidDownloadUrl);
      }
    }
  },
  // 获取品专域名
  async gettradeListUrl({ commit }) {
    const res = await queryConfigValue({ key: 'H5URLBeforeA'});
   
    commit('SET_TRADE_LIST_URL', res)
  },

  async getTradeWapLink({ commit, state }) {
    if(state.tradeWapLink) {
      return state.tradeWapLink
    }
    try {
      const res = await queryConfigValue({key: 'H5LinkMT5'});
      const defaultLink = 'https://h5pro.rlc561.com';
      if(res) {
        commit('SET_TRADE_WAP_LINK', res)
        return res
      } else {
        return defaultLink
      }
    } catch (e) {
      return defaultLink
    }
  },
  async getCustomerService({ commit },  key = 'PmUcLiveUrl') {
    const res = await queryConfigValue({key});
    if(res) {
      if(key === 'PmUcLiveUrl') {
        sessionStorage.setItem('liveUC', res)
        commit('SET_LIVE_UC_URL', res)
      } else {
        sessionStorage.setItem('liveH5', res)
        commit('SET_LIVE_URL', res)
      }
    }
  },
  toLive800({ state }, type) {
    window.open(
      type === 'wap' ? state.live800Url : state.live800UrlUc
    );
  },
  // 读网易易盾行为验证码配置，返回 { toggle, captchaId }（都是原始字符串，判断留给调用方）。
  // 每次点「获取验证码」都请求一遍没必要，这里拿到一次就存下来，后续直接命中缓存。
  getYidunCaptchaConfig({ state, commit }) {
    if (state.yidunCaptchaConfig) {
      return Promise.resolve(state.yidunCaptchaConfig)
    }
    if (yidunConfigPromise) {
      return yidunConfigPromise
    }
    // 单个 key 各自兜底：拿不到就当空串，让调用方走「开关读不到默认走验证」的安全分支
    yidunConfigPromise = Promise.all([
      queryConfigValue({ key: TOGGLE_CONFIG_KEY }).catch(() => ''),
      queryConfigValue({ key: CAPTCHA_ID_CONFIG_KEY }).catch(() => ''),
    ]).then(([toggle, captchaId]) => {
      const config = { toggle: toggle == null ? '' : String(toggle), captchaId: captchaId || '' }
      // 只缓存有结论的结果：开关明确为 0（跳过验证），或拿到了业务ID（可以验证）。
      // 两者都没拿到多半是请求失败/后台没配，不缓存，下次点击重试，避免把一次抖动固化成
      // 整个页面生命周期内都验不了码
      if (config.toggle === '0' || config.captchaId) {
        commit('SET_YIDUN_CAPTCHA_CONFIG', config)
      }
      return config
    }).finally(() => {
      yidunConfigPromise = null
    })
    return yidunConfigPromise
  },
   
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}